export class PersistentNotification {
  uuid: string;
  created: Date;
  type: string;
  data: any;
  viewed?: boolean;
}

export enum PersistentNotificationType {
  FILE_READY = "File ready",
}

export const VIEWED_PERSISTENT_NOTIFICATION_STORAGE_KEY =
  "viewed-notifications";
